
import './navigation.tpl.php';
import './navigation.scss'
import 'imports?jQuery=jquery!bootstrap-sass/assets/javascripts/bootstrap/transition.js';
import 'imports?jQuery=jquery!bootstrap-sass/assets/javascripts/bootstrap/collapse.js';



// WEBPACK FOOTER //
// ./src/components/navigation/index.js